import { IconButton, CircularProgress } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ChapterButtonClickHandler, ChapterNavigationDirection } from './types';
import { useTranslation } from 'react-i18next';

export default function IconVariant({
  onClick,
  loading,
  direction,
}: Readonly<{
  direction: ChapterNavigationDirection;
  onClick: ChapterButtonClickHandler;
  loading: boolean;
}>) {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={onClick}
      sx={{ padding: 1.75 }}
      aria-label={
        direction === 'previous'
          ? t('readingView.navigation.chapter.moveTo.previous.aria')
          : t('readingView.navigation.chapter.moveTo.next.aria')
      }
    >
      {direction === 'previous' && !loading && (
        <ArrowBackIosIcon
          fontSize='small'
          sx={{ color: 'action.active' }}
          role='presentation'
        />
      )}
      {loading && (
        <CircularProgress
          size={20}
          sx={{ color: 'action.active' }}
          role='presentation'
        />
      )}
      {direction === 'next' && !loading && (
        <ArrowForwardIosIcon
          fontSize='small'
          sx={{ color: 'action.active' }}
          role='presentation'
        />
      )}
    </IconButton>
  );
}
